import { render } from "./edit.vue?vue&type=template&id=0e35f10d&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=0e35f10d&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e35f10d"],['__file',"src/views/mediaLibrary/tag/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e35f10d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e35f10d', __exports__)) {
    console.log('reload')
    api.reload('0e35f10d', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=0e35f10d&scoped=true", () => {
    console.log('re-render')
    api.rerender('0e35f10d', render)
  })

}


export default __exports__